import {
  Edit,
  SimpleForm,
  TextInput,
  Datagrid,
  List,
  TextField,
  Create,
} from "react-admin";
import { Developer } from "./Developer";
export const EnvironmentList = () => (
  <List resource="environment" title={"Environments"}>
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <TextField source="description" />
    </Datagrid>
  </List>
);

export const EnvironmentCreate = (props) => (
  <Create  {...props}>
    <SimpleForm>
      <TextInput  label="Name" source="name" />
      <TextInput  label="Description" source="description" />
    </SimpleForm>
  </Create>
);

export const EnvironmentEdit = props =>(
  <Edit {...props}>
    <SimpleForm>
      <TextInput  label="Name" source="name" />
      <TextInput  label="Description" source="description" />
      <Developer/>
    </SimpleForm>
  </Edit>
);